import {inject, Injectable, Injector, runInInjectionContext} from '@angular/core';
import {Functions, httpsCallable}                            from '@angular/fire/functions';
import {OutgoingDataIntf, Session}                           from '@djsharkk/logr-types';
import {BehaviorSubject}                                     from 'rxjs';
import {DataFactoryBase}                                     from '../data-factory.base';
import {DataFilterService}                                   from '../data-filter.service';

@Injectable({
				providedIn: 'root'
			})
export class DataRizeService extends DataFactoryBase {
	injector = inject(Injector)
	svcDataFilters = inject(DataFilterService)
	rizeSessions = new BehaviorSubject<Session[]>([])


	async initializeData() {
		await runInInjectionContext(this.injector, async () => {
			this.getRizeApi(this.svcDataFilters.dateStart, this.svcDataFilters.dateEnd)
				.then(
					(sessions) => {
						this.rizeSessions.next(sessions.data.map(session => ({
							...session,
							startTime: new Date(session.startTime),
							endTime  : new Date(session.endTime)
						})))
					}
				)
				.catch(
					(err) => {
						console.log(err)
					}
				)
		})

		return
	}


	getRizeApi(dateStart: Date, dateEnd: Date) {
		const functions = inject(Functions)
		const getData = httpsCallable<OutgoingDataIntf, Session[]>(functions, 'fetchRizeSessions');
		return getData({
						   dateStart,
						   dateEnd
					   });
	}


}
